import React, {forwardRef} from 'react';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';

import type {ComponentPropsWithoutRef} from 'react';


export type NativeLabelProps = Omit<ComponentPropsWithoutRef<'label'>, 'title'>;

export interface LabelBaseProps extends NativeLabelProps {
    /**
     * Ellipsis for too long text
     */
    ellipsis?: boolean,
    /**
     * Tooltip caption (is visible only, if Label has ellipsis)
     */
    title?: string,
}

export const LabelBase = forwardRef<HTMLLabelElement, LabelBaseProps>(function LabelBase({
    ellipsis = true,
    title,
    children = '',
    ...props
}, ref) {

    return (

        <label {...props} ref={ref}>
            {ellipsis ? (
                <EllipsisTextHint title={title} isActive={ellipsis}>
                    {children}
                </EllipsisTextHint>
            )
                : children}
        </label>
    );
});

LabelBase.displayName = 'LabelBase';
